export const DATA_ADAPTER_TABLE_ID = "dataAdapterTableID";
export const attributes = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    searchable: true
  },
  {
    id: "description",
    title: "Description",
    type: "STRING"
  },
  {
    id: "name",
    title: "Name",
    type: "STRING"
  },
  {
    id: "throughput",
    title: "Throughput",
    type: "STRING"
  }
];
export const adapterListElements = {
  defaultLayout: {
    entityTableId: DATA_ADAPTER_TABLE_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: ["title", "description", "name", "throughput"],
    defaultColumnOrder: ["title", "description", "name", "throughput"]
  }
};
